import { memo, useMemo } from 'react';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';

import { OfferScheduleType } from '../../OfferFilters.types';

interface IScheduleFilterProps {
  selected: OfferScheduleType[];
  onSelectionChange: (values: OfferScheduleType[]) => void;
}

const SCHEDULE_OPTIONS: FilterOption[] = [
  { label: 'Permanent', value: OfferScheduleType.PERMANENT },
  { label: 'Interval', value: OfferScheduleType.INTERVAL }
];

export const ScheduleFilter = memo(({ selected, onSelectionChange }: IScheduleFilterProps) => {
  const selectedValues = useMemo(() => selected.map(String), [selected]);

  return (
    <FilterPopover
      label="Schedule"
      filterType={FilterType.CHECKLIST}
      options={SCHEDULE_OPTIONS}
      selectedItems={selectedValues}
      onSelectionChange={onSelectionChange as (items: string[]) => void}
      dataTestId="offers-schedule-filter"
      popoverHeight="auto"
    />
  );
});

ScheduleFilter.displayName = 'ScheduleFilter';
